// extracted by mini-css-extract-plugin
export default {"compet_cdp":"CoupeFrance_compet_cdp__4Me42","compet_cdp_content":"CoupeFrance_compet_cdp_content__knR2N","cdp_title":"CoupeFrance_cdp_title__A1ioq"};